module.exports = __webpack_public_path__ + "media/images/front/services/after_sales_service-53e198990acef149581b20d08423b94a.jpg";